import React, { useState, useEffect } from 'react'
import axios from 'axios';
import {getCsrfToken} from '../../commons/authenticityToken';
import LoadingOverlay from 'react-loading-overlay';

interface user {
  name:                      string;
  name_kana:                 string;
  email:                     string;
  password:                  string;
  confirm_password:          string;
  mail_notice_flag:          Number;
  user_kbn:                  string;
  current_sign_in_at_and_ip: string;
  last_sign_in_at_and_ip:    string;
}

interface profilePassword {
  id:                        Number;
  current_password:          string;
  password:                  string;
  confirm_password:          string;
}

interface radio {
  label: string
  value: number
}

const Index = (props) => {
  axios.defaults.headers.common['X-CSRF-Token'] = getCsrfToken();

  // ユーザー
  let userInit = {
    name:             "",
    name_kana:        "",
    email:            "",
    password:         "",
    confirm_password: "",
    mail_notice_flag: 1,
    user_kbn:         "reader",
    ik:               props.m_user.ik,
    m_institution_id: props.m_user.m_institution_id,
    current_sign_in_at_and_ip: "",
    last_sign_in_at_and_ip:    ""
  } as user

  let profilePasswordInit = {
    id:                 props.m_user.id,
    current_password:   "",
    password:   "",
    confirm_password: ""
  }

  // メール通知区分
  let mailKbns: radio[] = [
    { label: "通知しない", value: 0},
    { label: "通知する", value: 1},
  ]

  // テンプレート内容
  const [user, setUser] = useState<user>(userInit);
  const [profilePassword, setProfilePassword] = useState<profilePassword>(profilePasswordInit);

  const [errorMessage, setErrorMessage] = useState("");

  // ロード系
  const [isLoading, setIsLoading]  = useState<Boolean>(false);

  // 初回ロード
  useEffect(() =>{
    if (props.action_name == "edit" || props.action_name == "profile"){
      setIsLoading(true);
      axios.get(
        '/api/internal/users/get_user?id=' + props.m_user.id, {})
      .then(function (response) {
        setUser(response.data.m_user)
      }).catch(error => {
        setErrorMessage(error.response.data.message);
        window.scrollTo({left: 0, top: 0, behavior: "smooth"});
      }).finally(() => {
        setIsLoading(false);
      });
    }
  },[]);

  // パスワード生成
  function generated_password(){
    setIsLoading(true);
    axios.get(
      '/api/internal/users/generated_password', {})
    .then(function (response) {
      setUser({...user, password: response.data.generated_password, confirm_password: response.data.generated_password});
    }).catch(error => {
      setErrorMessage(error.response.data.message);
      window.scrollTo({left: 0, top: 0, behavior: "smooth"});
    }).finally(() => {
      setIsLoading(false);
    });
  }

  // パスワード表示
  function viewPassword(checked){
    const userPassword = document.getElementById('m_user_password');
    const userConfirmPassword = document.getElementById('m_user_confirm_password');
    if(checked){
      userPassword.setAttribute('type', 'text');
      userConfirmPassword.setAttribute('type', 'text');
    }else{
      userPassword.setAttribute('type', 'password');
      userConfirmPassword.setAttribute('type', 'password');
    }
  }

  // ラジオボタンの変更
  const changeMailKbn = (event: React.ChangeEvent<HTMLInputElement>) => setUser({...user, mail_notice_flag: Number(event.target.value)});
  
  const changeUserKbn = (event: React.ChangeEvent<HTMLInputElement>) => setUser({...user, user_kbn: event.target.value});

  // 登録・更新処理
  function submitUser() {
    setIsLoading(true);
    if (props.action_name == "edit" || props.action_name == "profile"){
      axios.post(
        '/api/internal/users/update', {m_user: user})
      .then(function (response) {
        location.href = (`/users/${props.m_user.m_institution_id}/index`);
      }).catch(error => {
        setErrorMessage(error.response.data.message);
        window.scrollTo({left: 0, top: 0, behavior: "smooth"});
      }).finally(() => {
        setIsLoading(false);
      });
    }else{
      axios.post(
        '/api/internal/users/create', {m_user: user})
      .then(function (response) {
        location.href = (`/users/${props.m_user.m_institution_id}/index`);
      }).catch(error => {
        setErrorMessage(error.response.data.message);
        window.scrollTo({left: 0, top: 0, behavior: "smooth"});
      }).finally(() => {
        setIsLoading(false);
      });
    }
  }

  function submitPassword(){
    setIsLoading(true);
    axios.post(
      '/api/internal/users/update_password', {m_user: profilePassword})
    .then(function (response) {
      location.reload()
    }).catch(error => {
      setErrorMessage(error.response.data.message);
      window.scrollTo({left: 0, top: 0, behavior: "smooth"});
    }).finally(() => {
      setIsLoading(false);
    });
  }

  return(
    <LoadingOverlay active={isLoading} spinner text="Loading...">
      { errorMessage && 
        <div className="alert alert-danger alert-dismissible" role="alert">
          <button type="button" className="close" data-dismiss="alert" aria-label="閉じる">
            <span aria-hidden="true">×</span>
          </button>
          { errorMessage }
        </div>
      }

      <div className="form-group">
        <label htmlFor="m_user_name">お名前</label><span className="label label-danger ml5">必須</span>
        <input className="form-control" autoComplete="off" placeholder="山田太郎" type="text" id="m_user_name" value={user.name} defaultValue={user.name} onChange={(e) => setUser({...user, name: e.target.value})}/>
      </div>

      <div className="form-group">
        <label htmlFor="m_user_name_kana">お名前カナ</label>
        <input className="form-control" autoComplete="off" placeholder="ヤマダタロウ" type="text" id="m_user_name_kana" value={user.name_kana} defaultValue={user.name_kana} onChange={(e) => setUser({...user, name_kana: e.target.value})}/>
      </div>

      <div className="form-group">
        <label htmlFor="m_user_email">メールアドレス</label><span className="label label-danger ml5">必須</span>
        <input disabled={props.action_name == "profile"} className="form-control" autoComplete="off" placeholder="taro@yoyaku.com" type="text" id="m_user_email" value={user.email} defaultValue={user.email} onChange={(e) => setUser({...user, email: e.target.value})}/>
      </div>

      {
        (props.action_name == "new" || props.action_name == "edit") &&
        <div className="form-group">
          <label htmlFor="m_user_password">パスワード</label>{props.action_name == "new" ? <span className="label label-danger ml5">必須</span> : <span className="red font_size_s">パスワードを変更したい場合は入力して下さい。</span>} 
          <div className="password_area">
            <div className="w100p">
              <input className="form-control" name="user-password" autoComplete="new-password" placeholder="8文字以上半角英数および-_@(大文字小文字英字および数値1文字以上含む)" type="password" id="m_user_password" value={user.password} defaultValue={user.password} onChange={(e) => setUser({...user, password: e.target.value})}/>
            </div>
            <div className="password_generated_button">
              <button className="btn btn-info" name="button" type="button" onClick={() => generated_password()}>生成</button>
            </div>
          </div>

          <label htmlFor="m_user_confirm_password">パスワード(確認)</label>
          <input className="form-control" placeholder="パスワード(確認)" autoComplete="off" type="password" id="m_user_confirm_password" value={user.confirm_password} defaultValue={user.confirm_password} onChange={(e) => setUser({...user, confirm_password: e.target.value})}/>
          <div className="felx_center">
            <input className="mt0" type="checkbox" id="show_password" onChange={(e) => viewPassword(e.target.checked)}/>
            <label className="font_size_s mb0" htmlFor="show_password">パスワードを表示する</label>
          </div>
       </div>
      }



      {/* 権限 */}
      <div className="form-group">
        <label>権限区分</label>
        {/* 作成・更新ユーザーがシステム管理企業のユーザーか */}
        { props.is_m_user_gcs_company ? 
        (
          <div className="radio-inline">
            {
              props.current_m_user.gcs_admin ? (
                <input checked={user.user_kbn == "admin"}　className="radio-input" type="radio" name="m_user[user_kbn]" value={"admin"} id={`m_user_user_kbn_0`} onChange={changeUserKbn}/>
              ):(
                <input checked={user.user_kbn == "admin"}　className="radio-input-disabled" type="radio" name="m_user[user_kbn]" value={"admin"} id={`m_user_user_kbn_0`} onChange={changeUserKbn} disabled={true}/> 
              )
            }
            <label className="m10" htmlFor={`m_user_user_kbn_0`}>管理者</label>

            <input checked={user.user_kbn == "reader"}　className="radio-input" type="radio" name="m_user[user_kbn]" value={"reader"} id={`m_user_user_kbn_1`} onChange={changeUserKbn}/>
            <label className="m10" htmlFor={`m_user_user_kbn_1`}>閲覧者</label>
            
            {
              props.current_m_user.gcs_editor_and_above ? (
                <input checked={user.user_kbn == "editor"}　className="radio-input" type="radio" name="m_user[user_kbn]" value={"editor"} id={`m_user_user_kbn_2`} onChange={changeUserKbn}/>
              ):(
                <input checked={user.user_kbn == "editor"}　className="radio-input-disabled" type="radio" name="m_user[user_kbn]" value={"editor"} id={`m_user_user_kbn_2`} onChange={changeUserKbn} disabled={true}/>
              )
            }
            
            <label className="m10" htmlFor={`m_user_user_kbn_2`}>編集者</label>
          </div>
        ):(
          <div className="radio-inline">
            {
              (props.current_m_user.gcs_editor_and_above || props.current_m_user.institution_admin) ? (
                <input checked={user.user_kbn == "admin"}　className="radio-input" type="radio" name="m_user[user_kbn]" value={"admin"} id={`m_user_user_kbn_0`} onChange={changeUserKbn}/>
              ):(
                <input checked={user.user_kbn == "admin"}　className="radio-input-disabled" type="radio" name="m_user[user_kbn]" value={"admin"} id={`m_user_user_kbn_0`} onChange={changeUserKbn} disabled={true}/> 
              )
            }
            <label className="m10" htmlFor={`m_user_user_kbn_0`}>管理者</label>

            <input checked={user.user_kbn == "reader"}　className="radio-input" type="radio" name="m_user[user_kbn]" value={"reader"} id={`m_user_user_kbn_1`} onChange={changeUserKbn}/>
            <label className="m10" htmlFor={`m_user_user_kbn_1`}>閲覧者</label>
          </div>
        )
        }
      </div>

      {/* メール通知 */}
      <div className="form-group">
        <label>メール通知</label>
        <div className="radio-inline">
          { mailKbns.map((mailKbn) =>{
            return (
              <>
                <input checked={mailKbn.value === user.mail_notice_flag}　className="radio-input" type="radio" name="m_user[mail_notice_flag]" value={mailKbn.value} id={`m_user_mail_notice_flag_${mailKbn.value}`} onChange={changeMailKbn}/>
                <label className="m10" htmlFor={`m_user_mail_notice_flag_${mailKbn.value}`}>{mailKbn.label}</label>
              </>
            )}) 
          }
        </div>
      </div>
      
      {
        (props.action_name == "edit" || props.action_name == "profile") && (
          <div className="form-group">
            <label>最新のログイン日時（IPアドレス）：</label>
            {user.current_sign_in_at_and_ip}
            <br/>
            <label>前回のログイン日時（IPアドレス）：</label>
            {user.last_sign_in_at_and_ip}
          </div>
        )
      }


      {/* ボタン類 */}
      <div>
        <div className="actions mt40">
          {
            (props.action_name == "new" || props.action_name == "edit") && <a className="btn btn-primary pull-left m5" href={`/users/${props.m_user.m_institution_id}/index`}>戻る</a> 
          }
          <a className="btn btn-primary pull-right m5" type="hidden" data-toggle="modal" data-target="#user_form_modal">
            {(props.action_name == "edit" || props.action_name == "profile") ? ("更新する") : ("登録する") }
          </a>
        </div>
      </div>

      {/* プロフィール画面用のパスワード */}
      {
        props.action_name == "profile" && (
        <>
          <div className="clearfix"/>
          <h3 className="h3">パスワード</h3>
          
          <div className="form-group">
            <label htmlFor="m_user_current_password">現在のパスワード</label><span className="label label-danger ml5">必須</span> 
              <input className="form-control" placeholder="8文字以上半角英数および-_@(大文字小文字英字および数値1文字以上含む)" type="password" id="m_user_current_password" value={profilePassword.current_password} defaultValue={profilePassword.current_password} onChange={(e) => setProfilePassword({...profilePassword, current_password: e.target.value})}/>
          </div>

          <div className="form-group">
            <label htmlFor="m_user_password">新しいパスワード</label><span className="label label-danger ml5">必須</span> 
            <input className="form-control" placeholder="8文字以上半角英数および-_@(大文字小文字英字および数値1文字以上含む)" type="password" id="m_user_password" value={profilePassword.password} defaultValue={profilePassword.password} onChange={(e) => setProfilePassword({...profilePassword, password: e.target.value})}/>
          </div>

          <div className="form-group">
            <label htmlFor="m_user_confirm_password">パスワード(確認)</label><span className="label label-danger ml5">必須</span> 
            <input className="form-control" placeholder="パスワード(確認)" type="password" id="m_user_confirm_password" value={profilePassword.confirm_password} defaultValue={profilePassword.confirm_password} onChange={(e) => setProfilePassword({...profilePassword, confirm_password: e.target.value})}/>
            <div className="felx_center">
              <input className="mt0" type="checkbox" id="show_password" onChange={(e) => viewPassword(e.target.checked)}/>
              <label className="font_size_s mb0" htmlFor="show_password">パスワードを表示する</label>
            </div>
          </div>

          <a className="btn btn-primary pull-right m5" type="hidden" data-toggle="modal" data-target="#password_form_modal">
            更新する
          </a>
        </>
        )
      }

      {/* 登録・更新確認 */}
      <div className="modal fade" data-backdrop="static" id="user_form_modal">
        <div className="sw-modal-content">
        <div className="sw-modal-dialog" style={{ minHeight: '363px'}}>
          <div className="sw-modal-icon-question sw-modal-icon">?</div>
          <h2>{(props.action_name == "edit" || props.action_name == "profile") ? ("更新する") : ("登録する") }</h2>
          <div className="sw-modal-body" style={{ marginBottom: '50px'}}>
            {(props.action_name == "edit" || props.action_name == "profile") ? ("この内容で更新します") : ("この内容で登録します") }
            <br />
            よろしいですか？<br />
          </div>
          <a type="button"
              className="sw-modal-btn"
              style={{ backgroundColor: '#3071a9', textDecoration: 'none'}}
              data-dismiss="modal"
              onClick={() => submitUser() }
          >
          {(props.action_name == "edit" || props.action_name == "profile") ? ("更新する") : ("登録する") }
          </a>
          <button type="button" className="sw-modal-btn" data-dismiss="modal">キャンセル</button>
        </div>
        </div>
      </div>

      {/* パスワード更新確認 */}
      <div className="modal fade" data-backdrop="static" id="password_form_modal">
        <div className="sw-modal-content">
        <div className="sw-modal-dialog" style={{ minHeight: '363px'}}>
          <div className="sw-modal-icon-question sw-modal-icon">?</div>
          <h2>更新する</h2>
          <div className="sw-modal-body" style={{ marginBottom: '50px'}}>
            パスワードを変更します。
            <br />
            よろしいですか？<br />
          </div>
          <a type="button"
              className="sw-modal-btn"
              style={{ backgroundColor: '#3071a9', textDecoration: 'none'}}
              data-dismiss="modal"
              onClick={() => submitPassword() }
          >
          更新する
          </a>
          <button type="button" className="sw-modal-btn" data-dismiss="modal">キャンセル</button>
        </div>
        </div>
      </div>
    </LoadingOverlay>
    )
}
export default Index;